'use strict';

exports.__esModule = true;
exports.Avatar = undefined;

var _Avatar2 = require('./Avatar');

var _Avatar3 = _interopRequireDefault(_Avatar2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar3.default;
exports.Avatar = _Avatar3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Avatars/index.js
// module id = 114
// module chunks = 168707334958949